import React, { useState, useEffect } from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';
import lockimage from 'assets/lock.png';
import ProfileConditionCard from '../ProfileConditionCard';
import ProfilePersonalInfoSection from '../ProfilePersonalInfoSection';
import PersonalProfileEditForm from '../PersonalProfileEditForm';
import { PROFILE_CONSTANTS } from '../../pages/Profile';
import ProfileChangePassword from '../ProfileChangePassword/ProfileChangePassword';
import { FormProvider, useForm } from 'react-hook-form';

interface ProfilePersonalInfoPageProps {
  active: string;
  profile: any;
  setActive: Function;
}

const ProfilePersonalInfoPage = ({ active, setActive }: ProfilePersonalInfoPageProps) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const methods = useForm();

  let time: NodeJS.Timeout;
  useEffect(() => {
    return () => clearTimeout(time);
  });
  const onSaved = () => {
    setIsEditMode(false);
  };
  return (
    <div className="__ProfilePersonalInfoPage f1 d-lg-flex">
      {active && active === PROFILE_CONSTANTS.PERSONAL_INFORMATION.key && (
        <div className="__profile-card __details-wrapper">
          <div className="d-flex justify-content-between">
            <h6 className="__primary-text-color font_montserrat font-weight-semi-bold">Personal info</h6>
            {isEditMode ? (
              <p className="__grey-text">Edit state</p>
            ) : (
              <button className="__edit-link font-weight-bold __normal-btn" onClick={() => setIsEditMode(true)}>
                Edit
              </button>
            )}
          </div>
          <FormProvider {...methods}>
            {isEditMode ? <PersonalProfileEditForm onSaved={onSaved} onCancel={() => setIsEditMode(false)} /> : <ProfilePersonalInfoSection />}
          </FormProvider>
        </div>
      )}
      {active && active === PROFILE_CONSTANTS.PASSWORD.key && (
        <div className="__profile-card __details-wrapper">
          <div className="d-flex justify-content-between">
            <h6 className="__primary-text-color font_montserrat font-weight-semi-bold">Personal info</h6>
          </div>
          <ProfileChangePassword onSuccess={() => setActive(PROFILE_CONSTANTS.PERSONAL_INFORMATION.key)} />
        </div>
      )}
      <div className="__condition-section d-none d-xl-block">
        <ProfileConditionCard title="Which details can be edited?" imageSrc={lockimage}>
          Details{' '}
          <Link to="/" className="__primary-text-color font-weight-semi-bold">
            Urbain
          </Link>{' '}
          uses to verify your identity can’t be changed. Contact info and some personal details can be edited, but we may ask you verify your identity
          the next time you book or create a listing.
        </ProfileConditionCard>
        <ProfileConditionCard title="What info is shared with others?" imageSrc={lockimage}>
          <Link to="/" className="__primary-text-color font-weight-semi-bold">
            Urbain
          </Link>{' '}
          only releases contact information for hosts and guests after a reservation is confirmed.
        </ProfileConditionCard>
      </div>
    </div>
  );
};

export default ProfilePersonalInfoPage;
